export enum AllocationType {
	Revenue = 1,
	Cost = 2
}